import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { AppState } from '../../../types/store';
import { getSoldExclusives } from '../../../selectors/reports';
import { Props } from './SoldExclusivesSection';

type StateProps = Pick<Props, 'data'>;
type DispatchProps = Pick<Props, never>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => ({
  data: getSoldExclusives(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {};

export default connect(mapStateToProps, mapDispatchToProps);
